import { render } from "./SecondaryTradeInfoModal.vue?vue&type=template&id=ac9ce356"
import script from "./SecondaryTradeInfoModal.vue?vue&type=script&lang=js"
export * from "./SecondaryTradeInfoModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__